<!--
Directions > building from screen
@author bmk11u, crm4f
-->
<template>
  <div id="contain" class="container">
    <Nav name="Directions from Building" v-bind:home="true" v-if="authenticated" />
    <Nav name="Directions from Building" v-if="!authenticated" />

    <FuzzySearchList :authenticated="authenticated===true" :initialLocations="buildingLocations" :fullLocations="buildingLocations" :aliasLocations="aliasLocations"
      searchPlaceholder="Search for a building..." :buildingId="buildingId" :toId="toId" :toType="toType"/>

    <div id="pusher"></div>
    <Footer active="locations" v-if="authenticated"/>
  </div>
</template>

<script setup>
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import { useMapCommon } from '@/composables/MapCommon.js'
import Footer from '@/components/FooterMenu.vue'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import FuzzySearchList from './FuzzySearchList.vue'

const { authenticated } = useLocationsCommon()
const { toLocation, urlToLocations } = useMapCommon()
const route = useRoute()

const buildingId = ref(null)
const toId = ref(null)
const toType = ref(null)
const buildingLocations = ref(null)
const aliasLocations = ref(null)

onMounted( async () => {
  console.log('authenticated:', authenticated.value)

  buildingId.value = route.query.buildingId
  toId.value = route.query.toId
  toType.value = route.query.toType

  // fetch locations data to be searched
  const [aliases, buildings] = await Promise.all([
    urlToLocations('/map/aliases', alias => toLocation(alias.locId, alias.aliasText)),
    urlToLocations('/map/buildings', building => toLocation(building.buildingId, building.buildingName))
  ])

  buildingLocations.value = buildings
  aliasLocations.value = aliases
})
</script>
